import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { SheetSummaryMembership } from '@hkm/components/Attendant/SheetSummary/models/SheetSummaryMembership';
import BadgeWithCount from '@hkm/components/shared/BadgeWithCount/BadgeWithCount';
import classNames from 'classnames';

import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import { FlexDirection, TextSize } from '@ac/mobile-components/dist/enums';

export interface MembershipInfoProps {
  membership: SheetSummaryMembership;
}

export const MembershipInfo: React.FC<MembershipInfoProps> = (
  props: MembershipInfoProps
) => {
  const { t } = useTranslation();

  return (
    <AcFlex direction={FlexDirection.column} testSelector="membership-info">
      <AcText size={TextSize.Main2}>
        {t('ATTENDANT_ASSIGNMENTS.SHEET_SUMMARY.VIPS_AND_MEMBERSHIPS.TYPE')}
      </AcText>

      <AcText size={TextSize.Main1}>{props.membership.description}</AcText>

      <AcText
        size={TextSize.Main2}
        className="ac-spacing-top-md ac-spacing-top-xs"
      >
        {t('ATTENDANT_ASSIGNMENTS.SHEET_SUMMARY.VIPS_AND_MEMBERSHIPS.LEVEL')}
      </AcText>

      <AcFlex wrapped={true}>
        {props.membership.levels.map((level, levelIndex) => (
          <BadgeWithCount
            key={levelIndex}
            count={level.count}
            badgeText={level.description}
            backgroundColor={level.color}
            className={classNames(
              levelIndex !== props.membership.levels.length - 1 &&
                'ac-spacing-right-sm',
              'ac-spacing-bottom-sm'
            )}
            testSelector="membership-info-level-badge"
          />
        ))}
      </AcFlex>
    </AcFlex>
  );
};

export default memo(MembershipInfo);



// WEBPACK FOOTER //
// ./src/components/Attendant/SheetSummary/body/VipsAndMemberships/MembershipInfo.tsx